
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/market-conduct/forum",
      function () {
        return require("private-next-pages/compliance/market-conduct/forum/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/market-conduct/forum"])
      });
    }
  